import { render, staticRenderFns } from "./PersistResponsavelView.vue?vue&type=template&id=2660295c&"
import script from "./PersistResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelView.vue?vue&type=script&lang=ts&"
import style0 from "./PersistResponsavelView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports